import { useState, useCallback, useEffect } from "react";
import { STEPS } from "components/RentalPaymentModal/constants/steps";
import PaymentMethod from "../components/PaymentMethod/PaymentMethod";
import BookingPaymentOptions from "../components/BookingPaymentOptions/BookingPaymentOptions";
import AdditionalInsurance from "components/RentalPaymentModal/components/AdditionalInsurance/AdditionalInsurance";

import {
  setSelectedToStep,
  setCompletedToStep,
  setSelectedAndWasSelectedToStep,
  isLastStep,
  setSelectedToStepById,
  getStepIndexById
} from "components/StepsMenu/utils";

const stepsList = [
  {
    id: STEPS.ADDITIONAL_INSURANCE.ID,
    title: STEPS.ADDITIONAL_INSURANCE.NAME,
    component: AdditionalInsurance,
    index: 0,
    stepNumber: 1,
    wasSelected: true,
    completed: false,
    selected: true,
    isHidden: (_, addInsuranceList, isTII) => isTII || Boolean(addInsuranceList?.insurances?.length)
  },
  {
    id: STEPS.PAYMENT_METHOD.ID,
    title: STEPS.PAYMENT_METHOD.NAME,
    component: PaymentMethod,
    index: 1,
    stepNumber: 2,
    wasSelected: false,
    completed: false,
    selected: false
  },
  {
    id: STEPS.PAYMENT_OPTIONS.ID,
    title: STEPS.PAYMENT_OPTIONS.NAME,
    component: BookingPaymentOptions,
    index: 2,
    stepNumber: 3,
    wasSelected: false,
    completed: false,
    selected: false
  }
];

function getInitialStepsData(data, addInsuranceList, isTII, steps) {
  let initialStepIndex = 0;

  return steps
    .filter(step => step?.isHidden ? step?.isHidden(data, addInsuranceList, isTII) : step)
    .map((step, stepIndex) => ({
      ...step,
      index: initialStepIndex++,
      stepNumber: initialStepIndex,
      selected: !stepIndex ? true : false,
      wasSelected: !stepIndex ? true : false
    }));
}

function filterStepsData(data, addInsuranceList, isTII, steps) {
  return steps
    .filter(step => step?.isHidden ? step?.isHidden(data, addInsuranceList, isTII) : step);
}

export const useRentalPaymentModalSteps = (rvData, addInsuranceList, isTII) => {
  const [steps, changeSteps] = useState(getInitialStepsData(rvData, addInsuranceList, isTII, stepsList));
  const [currentStepIndex, setCurrentStepIndex] = useState(0);

  const onClickStep = useCallback(({ steps, selectedStepIndex }) => {
    changeSteps(setSelectedToStep(steps, selectedStepIndex));
    setCurrentStepIndex(selectedStepIndex);
  }, []);

  const onClickStepById = useCallback((stepId) => {
    changeSteps(setSelectedToStepById(steps, stepId));
    setCurrentStepIndex(getStepIndexById(steps, stepId));
  }, [steps]);

  const onNextStep = useCallback(() => {
    changeSteps(setCompletedToStep(setSelectedAndWasSelectedToStep(steps, currentStepIndex + 1), currentStepIndex));
    if (!isLastStep(steps, currentStepIndex)) {
      setCurrentStepIndex(currentStepIndex + 1);
    }
  }, [currentStepIndex, steps]);

  const onPrevStep = useCallback(() => {
    setCurrentStepIndex(currentStepIndex - 1);
  }, [currentStepIndex]);

  useEffect(() => {
    if (addInsuranceList && rvData) {
      if (!currentStepIndex) {
        changeSteps(getInitialStepsData(rvData, addInsuranceList, isTII, stepsList));
      } else {
        changeSteps(filterStepsData(rvData, addInsuranceList, isTII, steps));
      }
    }
  }, [addInsuranceList, currentStepIndex, isTII, rvData]);

  return {
    steps,
    currentStepIndex,
    onClickStep,
    onClickStepById,
    onNextStep,
    onPrevStep
  };
};
